<div class="flex flex-col-reverse fixed bottom-0 left-0 right-0 z-50 pointer-events-none elio-toast">
  <div *ngFor="let toast of toasts$ | async" @translateX class="w-fit-content mb-4 mx-4">
    <elio-toast-message
      class="flex w-fit-content items-center text-gray-dark p-4 rounded-lg bg-white border border-{{
        toast.type
      }} shadow-xl pointer-events-auto"
      [delay]="toast.delay"
      (hide)="remove(toast)"
      aria-atomic="true"
      aria-live="polite"
    >
      <elio-svg-icon *ngIf="!toast.icon" class="text-{{ toast.type }} mr-2 text-xl" [key]="toast.type"></elio-svg-icon>
      <elio-svg-icon *ngIf="toast.icon" class="text-gray mr-2 text-xl" [key]="toast.icon"></elio-svg-icon>
      <span innerHtml="{{ toast.message | transloco: toast?.params }}"></span>
      <button class="cursor-pointer ml-4" (click)="remove(toast)" data-qa="toast-close">
        <elio-svg-icon class="text-xs text-gray-900" key="cross"></elio-svg-icon>
      </button>
    </elio-toast-message>
  </div>
</div>
